import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { filterByPrice } from "../../features/products/productsSlice";

import Poster from '../Poster/Poster';
import Products from '../Products/Products';
import Categories from '../Categories/Categories';
import Banner from '../Banner/Banner';


const Home = () => {
  const dispatch = useDispatch();
  const { products: { list, filtered }, categories } = useSelector((state) => state); 

  useEffect(() => {
    if(!list.length) return;

    dispatch(filterByPrice(50))
  }, [dispatch, list.length]);

  return (
    <>
    <Poster />
    <Products products={list} amount={5} title="Trending" />
    <Categories categories={categories.list} amount={5} title="Worth seeing" />
    <Banner />
    <Products products={filtered} amount={5} title="Less than 50$" />
    </>
  )
}

export default Home